/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesCrossPlaySendInGameEventRequest interface.
 */
export function instanceOfFxIdWebFeaturesCrossPlaySendInGameEventRequest(value) {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    if (!('EventCode' in value) || value['EventCode'] === undefined)
        return false;
    if (!('Value' in value) || value['Value'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesCrossPlaySendInGameEventRequestFromJSON(json) {
    return FxIdWebFeaturesCrossPlaySendInGameEventRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesCrossPlaySendInGameEventRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'],
        'EventCode': json['EventCode'],
        'Value': json['Value'],
    };
}
export function FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSON(json) {
    return FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
        'EventCode': value['EventCode'],
        'Value': value['Value'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesCrossPlaySendInGameEventRequest.js.map